import {WarehouseLogin} from 'constants/WarehouseConstants';
import * as net from 'util/Net';

interface WarehouseLogins {
  logins: Array<WarehouseLogin>;
}

export function fetchLogins(): Promise<WarehouseLogins> {
  return Promise.resolve(net.getJSON('/1/api/warehouse/logins'));
}

export function createLogin(label: string): Promise<WarehouseLogin> {
  return Promise.resolve(
    net.postJSON({
      url: '/1/api/warehouse/logins',
      data: {label},
    })
  );
}

export function revokeLogin(login: WarehouseLogin): Promise<WarehouseLogin> {
  return Promise.resolve(net.delete_({url: `/1/api/warehouse/logins/${login.id}`}));
}
